import {
  enumInventoryTagSortOption,
  InventoryTagSortOption,
  InventoryTagStatus,
  TagType,
} from '@rematter/frontend-lib-api-client';
import { atom } from 'jotai';

import { inventoryTagsQueryAtom } from '../_graphql/queryInventoryTags';

import { atomFromQueryString } from '~/shared/state';

export const $searchTerm = atomFromQueryString.string('q');
export const $selectedFacility = atomFromQueryString.string('f');
export const $selectedTagType = atomFromQueryString.string('type');
export const $selectedStatus = atomFromQueryString.string('status');
export const $limit = atomFromQueryString.number('limit', 25);
export const $offset = atomFromQueryString.number('offset', 0);

export const $currentSorting = atom<InventoryTagSortOption[]>([
  enumInventoryTagSortOption.TagNumberAsc,
]);

export const $isCreateDialogOpen = atom(false);
export const $editingTagId = atom<string | null>(null);

export const $remoteInventoryTags = inventoryTagsQueryAtom((get) => {
  const searchTerm = get($searchTerm);
  const selectedFacility = get($selectedFacility);
  const selectedTagType = get($selectedTagType);
  const selectedStatus = get($selectedStatus);
  const limit = get($limit);
  const offset = get($offset);
  const sorting = get($currentSorting);

  const params: {
    searchTerm?: string;
    facilityId?: string;
    tagType?: TagType[];
    status?: InventoryTagStatus[];
    limit: number;
    offset: number;
    sorting: InventoryTagSortOption[];
  } = {
    limit,
    offset,
    sorting,
  };

  if (searchTerm) params.searchTerm = searchTerm;
  if (selectedFacility && selectedFacility !== 'all') {
    params.facilityId = selectedFacility;
  }
  if (selectedTagType && selectedTagType !== 'all') {
    params.tagType = [selectedTagType as TagType];
  }
  if (selectedStatus && selectedStatus !== 'all') {
    params.status = [selectedStatus as InventoryTagStatus];
  }

  return {
    variables: params,
  };
});
